import { useMutation, useQuery } from "react-query";
import useAuth from "./useAuth";

/**
 * Custom hook for resend the mails
 * @hook useResendMail
 * @author Tushar Sharma
 *
 */

export default function useResendMail() {
  const { request } = useAuth();

  const { mutateAsync: resendUserMail, isLoading: isResendUserMail } =
    useMutation("/resend-mail/user-resend", (payload: any) =>
      request
        .post("/resend-mail/user-resend", payload)
        .then((response) => response?.data as any)
    );

  //Resend Payment Schedule
  const {
    mutateAsync: resendPaymentSchedule,
    isLoading: isResendPaymentSchedule,
  } = useMutation("/resend-mail/resend-payment-schedule", (payload: any) =>
    request
      .post("/resend-mail/resend-payment-schedule", payload)
      .then((response) => response?.data as any)
  );

  //Resend Payment Schedule
  const { mutateAsync: resendSinglePayment, isLoading: isResendSinglePayment } =
    useMutation("/resend-mail/resend-single-payment", (payload: any) =>
      request
        .post("/resend-mail/resend-single-payment", payload)
        .then((response) => response?.data as any)
    );

  // Resend payment reminder
  const {
    mutateAsync: resendPaymentReminder,
    isLoading: isResendPaymentReminder,
  } = useMutation("/resend-mail/resend-payment-reminder", (payload: any) =>
    request
      .post("/resend-mail/resend-payment-reminder", payload)
      .then((response) => response?.data as any)
  );

  // const { mutateAsync: resendUserMail, isLoading: isResendUserMail } = useMutation(
  //   "/resend-mail/user-resend",
  //   (payload: any) =>
  //     request
  //       .post("/resend-mail/user-resend", payload)
  //       .then((response) => response?.data as any)
  // );
  const { mutateAsync: resendLetterMail, isLoading: isResendLetterMail } =
    useMutation("/resend-mail/letter-resend", (payload: any) =>
      request
        .post("/resend-mail/letter-resend", payload)
        .then((response) => response?.data as any)
    );
  const { mutateAsync: resendTodoMail, isLoading: isResendTodoMail } =
    useMutation("/resend-mail/addTodo-resend", (payload: any) =>
      request
        .post("/resend-mail/addTodo-resend", payload)
        .then((response) => response?.data as any)
    );

  const {
    mutateAsync: resendCompletedTodoMail,
    isLoading: isResendCompletedTodoMail,
  } = useMutation("/resend-mail/completeTodo-resend", (payload: any) =>
    request
      .post("/resend-mail/completeTodo-resend", payload)
      .then((response) => response?.data as any)
  );

  return {
    resendUserMail,
    isLoading:
      isResendUserMail ||
      isResendPaymentReminder ||
      isResendLetterMail ||
      isResendTodoMail ||
      isResendCompletedTodoMail,
    resendPaymentSchedule,
    isResendPaymentSchedule,
    resendSinglePayment,
    isResendSinglePayment,
    resendPaymentReminder,
    resendLetterMail,
    resendTodoMail,
    resendCompletedTodoMail,
  };
}
